import { axiosV1 } from 'interceptors/axios';
import { updateSocietyData } from 'modules/society/redux/updateSocietyData';
import types from 'redux/actions/actionTypes';
import { decryptResponse } from 'utils/token';

import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams, Communication, EmailData } from 'types';
import { Dispatch } from 'redux';

type CreateCommunicationProps = {
  emailData: any;
  files?: File[];
};

type GetCommunicationsProps = {
  societyId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

type UpdateCommunicationProps = {
  communicationId: string;
  updateCommunicationData: Partial<Communication>;
};

type CommunicationsApiGetAllResponse = {
  data: Communication[];
  total: number;
};

export type CommunicationMutationResponse = {
  communication: Communication;
  communicationsCount: { total: number; unread: number };
};

export const createCommunication =
  ({ emailData, files }: CreateCommunicationProps) =>
  async (dispatch: Dispatch) => {
    const formData = new FormData();

    formData.append('data', JSON.stringify(emailData));

    if (files?.length) {
      files.forEach((file) => {
        formData.append('files', file);
      });
    }

    const { data } = await axiosV1.post(`/comms`, formData, {
      headers: {
        'content-Type': 'multipart/form-data',
      },
    });

    const decodedData = (await decryptResponse(
      data
    )) as CommunicationMutationResponse;

    dispatch({
      type: types.CREATE_COMMUNICATION,
      communication: decodedData.communication,
    });

    updateSocietyData(decodedData, dispatch);
    return decodedData.communication;
  };

export const getCommunications =
  ({ societyId, params = {}, signal }: GetCommunicationsProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get('/comms', {
        params: {
          societyId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as CommunicationsApiGetAllResponse;

      dispatch({
        type: types.GET_COMMUNICATIONS,
        communications: decodedData.data,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updateCommunication =
  ({ communicationId, updateCommunicationData }: UpdateCommunicationProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateCommunicationData };

    const { data } = await axiosV1.put(`/comms/${communicationId}`, body);
    const decodedData = (await decryptResponse(
      data
    )) as CommunicationMutationResponse;

    updateSocietyData(decodedData, dispatch);

    dispatch({
      type: types.UPDATE_COMMUNICATION,
      communication: decodedData?.communication,
    });
  };

export const deleteCommunication =
  (communicationId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.delete(`/comms/${communicationId}`);
      const decodedData = await decryptResponse(data);

      updateSocietyData(decodedData, dispatch);

      dispatch({
        type: types.DELETE_COMMUNICATION,
        communicationId,
      });
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
